// extracted by mini-css-extract-plugin
export default {"stores":"StoresButtons_stores__IplhP","storesBlock":"StoresButtons_storesBlock__fwzPQ","storesItem":"StoresButtons_storesItem__Sc70U"};